import(/* webpackMode: "eager", webpackExports: ["FavoritesView"] */ "/app/src/views/favorites/FavoritesView.tsx");
